export default {
  TAILLE: "TAILLE",
  COLORIS: "COLORIS",
  TC: "TC"
}
